/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-key */
import React, { FunctionComponent, Fragment } from 'react';
import classnames from 'classnames';
import { Box, Typography, Paper } from '@mui/material'
import { Constants } from '../../../../utils';
import { IBreakdownReport } from '../../../../interfaces/calculator.interface';
import {
  ISubCategoryReport,
  ILineReport,
} from '../../../../interfaces/report.interface';
import { IInterventionsChecklist } from '../../../../interfaces/interventions.interface';
import useStyles from './ReportFooterBreakdown.styles';
import { getReportFooterBreakdown } from './ReportFooterBreakdownMap';

interface IProps{
  report: IBreakdownReport;
  interventionsChecklist: IInterventionsChecklist;
}

const CELL_PARTITIONS: Record<string, string> = {
  1: 'full',
  2: 'half',
  3: 'third',
};

const ReportFooter: FunctionComponent<IProps> = () => {
  const classes = useStyles();
  let rowIdx = 1;
  const getRowIndex = () => `row__${rowIdx++}`;

  const buildSubCells = (values: string[] | number[] = [], isDefault: boolean = true) => {
    let partitionClass = CELL_PARTITIONS[3];
    let validValues = [...values];

    if (!isDefault) {
      validValues = (values as any[]).filter(t => t !== '');
      const numberOfValues = validValues.length;
      partitionClass = CELL_PARTITIONS[numberOfValues];
    }

    return (
      <Box display="flex" flexWrap="wrap">
        {validValues.map(val => (
          <Box
            key={getRowIndex()}
            className={classnames(classes.valueCell, classes[partitionClass as keyof typeof classes])}
          >
            {val === 'undefined' ? Constants.STRING_TYPES.EMPTY : val}
          </Box>
        ))}
      </Box>
    );
  };

  const getLines = (lines: ILineReport[] = []) => {
    return lines.map(line => (
      <Box key={getRowIndex()} mb={2}>
        <Typography className={classnames(classes.subsectionTitle, classes.smallText)}>
          {line.description}
        </Typography>
        {line.note && (
          <Typography className={classes.noteText}>{`Note: ${line.note}`}</Typography>
        )}
        <Box className={classes.multiCont}>
          {buildSubCells(line.values, line.displayDefault)}
        </Box>
      </Box>
    ));
  };

  const getSubCategories = (subCategories: ISubCategoryReport[] = []) => {
    return subCategories.map(s => {
      if (!s.visible) return null;

      return (
        <Fragment key={getRowIndex()}>
          {!s.isInfoBlock && !s.isFootnoteBlock && (
            <Box mb={1}>
              <Typography className={classes.sectionTitle}>{s.title}</Typography>
            </Box>
          )}

          {s.isInfoBlock || s.isFootnoteBlock ? (
            <Box
              mt={s.isFootnoteBlock ? 2 : 0}
              className={classnames(
                s.isInfoBlock ? classes.infoBlock : classes.footnoteBlock
              )}
            >
              {s.lines.map(line => (
                <Box key={getRowIndex()} className={classes.specialBlock}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: line.description
                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                        .replace(/\n\n/g, '<br/><br/>'),
                    }}
                  />
                </Box>
              ))}
            </Box>
          ) : (
            getLines(s.lines)
          )}
        </Fragment>
      );
    });
  };

  const categories = getReportFooterBreakdown();

  return (
    <Box className={classes.container} mt={1} display="flex"  flexDirection="column">
      <Paper variant="outlined" className={classes.tableContainer} style={{ flex: 1 }}>
        {categories.slice(0, Math.ceil(categories.length / 2)).map(cat => (
          <Box key={getRowIndex()} mb={3}>
            {cat.subCategories && getSubCategories(cat.subCategories)}
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default ReportFooter;